export const RQ_GET_ALL_PRODUCT_API = {
  url: 'api/product/lookup/all/active',
  method: 'GET',
  auth: false,
};

export const RQ_PUT_PRODUCT_API = {
  url: 'api/product/register',
  method: 'POST',
  auth: true,
};

export const RQ_PUT_UPDATE_PRODUCT_API = {
  url: 'api/product/<%= id %>/update/allfields',
  method: 'PUT',
  auth: true,
};

export const RQ_PRODUCTS_BY_FILTER_API = {
  url: 'api/product/lookup/byfilter',
  method: 'GET',
  auth: false,
  search: true,
};
export const RQ_DELETE_PRODUCT_API = {
  url: 'api/product/delete/<%= id %>',
  method: 'DELETE',
  auth: true,
};
